import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, XCircle } from 'lucide-react';
import i18n from '../../../../../i18n';


export class ClientPaymentSuccess extends React.Component {
  render() {
    return (
      <React.Fragment>
        <section>
          <div
            className="bannerimg cover-image sptb-2"
            data-image-src="../assets/images/banners/banner2.jpg"
          >
            <div className="header-text mb-0">
              <div className="container">
                <div className="text-center text-white">
                  <h1>{i18n.t('payment_successful')}</h1>
                  <ol className="breadcrumb text-center">
                    <li className="breadcrumb-item">
                      <Link exact="true" to="/">{i18n.t('home')}</Link>
                    </li>
                    <li className="breadcrumb-item active text-white" aria-current="page">
                      {i18n.t('payment')}
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="sptb">
          <div className="container">
            <div className="container text-center">
              <div style={{ marginBottom: '1.5rem' }}>
                <CheckCircle size={64} color="#10b981" />
              </div>
              <h1 className="h2 mb-3">{i18n.t('payment_successful')}</h1>
              <p className="h4 font-weight-Automatic mb-4 leading-Automatic">
                {i18n.t('payment_success_message')}
              </p>
              <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                <Link className="btn btn-primary" to="/winning_bids">
                  {i18n.t('my_winnings')}
                </Link>
                <Link className="btn btn-secondary" to="/">
                  {i18n.t('home')}
                </Link>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export class ClientPaymentCancelled extends React.Component {
  render() {
    return (
      <React.Fragment>
        <section>
          <div
            className="bannerimg cover-image sptb-2"
            data-image-src="../assets/images/banners/banner2.jpg"
          >
            <div className="header-text mb-0">
              <div className="container">
                <div className="text-center text-white">
                  <h1>{i18n.t('payment_cancelled')}</h1>
                  <ol className="breadcrumb text-center">
                    <li className="breadcrumb-item">
                      <Link exact="true" to="/">{i18n.t('home')}</Link>
                    </li>
                    <li className="breadcrumb-item active text-white" aria-current="page">
                      {i18n.t('payment')}
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="sptb">
          <div className="container">
            <div className="container text-center">
              <div style={{ marginBottom: '1.5rem' }}>
                <XCircle size={64} color="#ef4444" />
              </div>
              <h1 className="h2 mb-3">{i18n.t('payment_cancelled')}</h1>
              <p className="h4 font-weight-Automatic mb-4 leading-Automatic">
                {i18n.t('payment_cancelled_message')}
              </p>
              <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                <Link className="btn btn-warning" to="/winning_bids">
                  {i18n.t('try_again')}
                </Link>
                <Link className="btn btn-secondary" to="/">
                  {i18n.t('home')}
                </Link>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}